import { Component, OnInit } from '@angular/core';
import { DatoPaginadoModel, Paging } from 'src/app/shared/models/dato-paginado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { DocumentoSubcategoriaService } from './documento-subcategoria.service';
import { TipoSolicitudEntry } from 'src/app/shared/entrys/tipo-solicitud.entry';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmarRespuestaComponent } from 'src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component';
import { ConfirmarRespuestaModel, ConfirmarRespuestaType } from 'src/app/shared/models/confirmar-respuesta.model';

@Component({
	selector: 'app-documento-subcategoria',
	templateUrl: './documento-subcategoria.component.html',
	styleUrls: ['./documento-subcategoria.component.scss']
})
export class DocumentoSubcategoriaComponent implements OnInit {

	dataTabla: DatoPaginadoModel;
	headerDocumentoSubcategoria: Array<string>;
	formDocumentoSubcategoria: FormGroup;
	selectDocumentoSubcategoria: any;
	paginaActual: number;

	// filtros
	filtro: FormGroup;
	public isCollapsed = true;

	// Selects
	documento: Array<any> = [];
	subCategoria: Array<any> = [];
	tipoSolicitud: Array<TipoSolicitudEntry> = [];

	constructor(private formBuilder: FormBuilder, private documentoSubcategoriaService: DocumentoSubcategoriaService,
		private modalService: NgbModal) {
		this.dataTabla = {
			paging: {} as Paging
		} as DatoPaginadoModel;

		this.createForm();
		this.selectDocumentoSubcategoria = null;
		this.paginaActual = 1;
	}

	ngOnInit() {
		this.headerDocumentoSubcategoria = ['Documento', 'Subcategoria',
			'Es obligatorio', 'Tipo Solicitud', 'Estado', 'Acción'];
		this.consultarListas();
		this.onConsultarDocumentoSubcategoria(1);
	}

	createForm() {
		this.formDocumentoSubcategoria = this.formBuilder.group({
			documento_id: [null, Validators.required],
			sub_categoria_id: [null, Validators.required],
			tipo_solicitud_id: [null, Validators.required],
			es_obligatorio: [true],
			activo: [true],
		});

		this.filtro = this.formBuilder.group({
			documento_id: [null],
			sub_categoria_id: [null],
			tipo_solicitud_id: [null],
			activo: [null],
		});
	}

	onConsultarDocumentoSubcategoria(page: number) {
		this.documentoSubcategoriaService.get({ ...this.filtro.value, numeroPagina: page })
			.subscribe(resultado => {
				if (resultado.result) {
					this.dataTabla = resultado.data as DatoPaginadoModel;
				}
			});
	}

	onPaginado(value: number) {
		this.paginaActual = value;
		this.onConsultarDocumentoSubcategoria(value);
	}

	onAgregarDocumentoSubcategoria() {
		this.documentoSubcategoriaService.create({
			...this.formDocumentoSubcategoria.value, activo: 1
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarDocumentoSubcategoria(this.paginaActual);
					this.formDocumentoSubcategoria.reset();
				}
			});
	}

	onOperarDocumentoSubcategoria() {
		if (!this.selectDocumentoSubcategoria) {
			this.onAgregarDocumentoSubcategoria();
		} else {
			this.onModificarDocumentoSubcategoria();
		}
	}

	onCargarDocumentoSubcategoria(entry: any) {
		entry.activo = entry.activo ? 1 : 0;
		entry.es_obligatorio = entry.es_obligatorio ? 1 : 0;
		this.formDocumentoSubcategoria.patchValue({
			...entry,
		});
		this.selectDocumentoSubcategoria = entry;
		this.formDocumentoSubcategoria.get('documento_id').disable();
		this.formDocumentoSubcategoria.get('sub_categoria_id').disable();
		this.formDocumentoSubcategoria.get('tipo_solicitud_id').disable();
	}

	onEliminarDocumentoSubcategoria(entry: any) {
		const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, { centered: true });
		const confirmarRespuesta = {} as ConfirmarRespuestaModel;
		confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
		confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
		modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
		modalRef.result.then(() => {
			this.documentoSubcategoriaService.delete(entry).subscribe(resultado => {
				if (resultado.result) {
					// tslint:disable-next-line:max-line-length
					const index = this.dataTabla.items
						// tslint:disable-next-line:no-shadowed-variable
						.findIndex(e => {
							if (e.documento_id === entry.documento_id &&
								e.sub_categoria_id === entry.sub_categoria_id &&
								e.tipo_solicitud_id === entry.tipo_solicitud_id) {
								return true;
							}
						});
					this.dataTabla.items.splice(index, 1);
					this.selectDocumentoSubcategoria = null;
					this.formDocumentoSubcategoria.reset();
				}
			});
		});
	}

	onModificarDocumentoSubcategoria() {
		this.documentoSubcategoriaService.update({
			...this.formDocumentoSubcategoria.value,
			documento_id: this.selectDocumentoSubcategoria.documento_id,
			sub_categoria_id: this.selectDocumentoSubcategoria.sub_categoria_id,
			tipo_solicitud_id: this.selectDocumentoSubcategoria.tipo_solicitud_id
		})
			.subscribe(resultado => {
				if (resultado.result) {
					this.onConsultarDocumentoSubcategoria(this.paginaActual);
					this.formDocumentoSubcategoria.get('tipo_solicitud_id').enable();
					this.formDocumentoSubcategoria.get('sub_categoria_id').enable();
					this.formDocumentoSubcategoria.get('documento_id').enable();
					this.formDocumentoSubcategoria.reset();
					this.selectDocumentoSubcategoria = null;
				}
			});
	}

	consultarListas() {
		this.documentoSubcategoriaService.getDocumento().subscribe(resultado => {
			if (resultado.data) {
				this.documento = resultado.data;
			}
		});

		this.documentoSubcategoriaService.getSubCategoria().subscribe(resultado => {
			if (resultado.result) {
				this.subCategoria = resultado.data;
			}
		});

		this.documentoSubcategoriaService.getTipoSolicitud().subscribe(resultado => {
			if (resultado.result) {
				this.tipoSolicitud = resultado.data;
			}
		});
	}

	filtrar() {
		this.paginaActual = 1;
		this.onConsultarDocumentoSubcategoria(1);
	}

	limpiar() {
		this.filtro.reset();
		this.filtrar();
	}
	limpiarDocumentoCategoria() {
		this.formDocumentoSubcategoria.get('tipo_solicitud_id').enable();
		this.formDocumentoSubcategoria.get('sub_categoria_id').enable();
		this.formDocumentoSubcategoria.get('documento_id').enable();
		this.formDocumentoSubcategoria.reset();
		this.selectDocumentoSubcategoria = null;
		this.createForm();
	}
}
